import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import BusinessSection from './components/BusinessSection';
import ServicesSection from './components/ServicesSection';
import PetSection from './components/PetSection';
import WellTerraSection from './components/WellTerraSection';
import NewsSection from './components/NewsSection';
import OverviewSection from './components/OverviewSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { SEOHead } from '../../components/SEOHead';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '一般社団法人 未来ウェルビーイング協会',
    url: siteUrl,
    logo: `${siteUrl}/vite.svg`,
    description: '人と社会、そしてペットのしあわせな未来をデザインします。ボディスキャン、LED光美容WellTerra、企業向け健康経営支援、ペット共生プログラムなど、こころ・からだ・つながりを整える新しい時代のウェルビーイングをカタチにします。',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '大阪市中央区',
      addressRegion: '大阪府',
      addressCountry: 'JP',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '34.6738',
      longitude: '135.5023',
    },
    areaServed: {
      '@type': 'Place',
      name: '大阪',
    },
    sameAs: [],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      areaServed: 'JP',
      availableLanguage: 'Japanese',
    },
    offers: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'ボディスキャン',
          description: '最新のボディスキャン技術で健康状態を可視化',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'LED光美容WellTerra',
          description: '先進的なLED光美容技術による美容ケア',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: '健康経営支援',
          description: '企業向けの健康経営コンサルティング',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'ペット共生プログラム',
          description: 'ペットと人が共に幸せに暮らすためのプログラム',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="一般社団法人 未来ウェルビーイング協会 | 大阪 心斎橋 健康経営 ペット共生 LED光美容"
        description="一般社団法人 未来ウェルビーイング協会は、大阪・心斎橋を拠点に、人と社会、そしてペットのしあわせな未来をデザインします。ボディスキャン、LED光美容WellTerra、企業向け健康経営支援、ペット共生プログラムなど、こころ・からだ・つながりを整える新しい時代のウェルビーイングをカタチにします。"
        keywords="ウェルビーイング,健康経営,ボディスキャン,LED光美容,ペット共生,大阪,心斎橋"
        canonical="/"
        ogTitle="一般社団法人 未来ウェルビーイング協会"
        ogDescription="人と社会、そしてペットのしあわせな未来をデザインする"
        ogType="website"
        ogUrl="/"
        schemaData={schemaData}
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <BusinessSection />
          <ServicesSection />
          <PetSection />
          <WellTerraSection />
          <NewsSection />
          <OverviewSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
